/* global GM_STATE */
import { useState, useEffect } from 'preact/hooks'

export const CartConfigKeys = {
  cart: 'cart',
  isLoading: 'isLoading',
  isFetching: 'isFetching'
}

function useCartGlobal() {
  const [cart, setCart] = useState(GM_STATE.cart.initCart)
  const [isFetching, setIsFetching] = useState(false)
  const [isLoaded, setIsLoaded] = useState(true)

  const [cartConfig, setCartConfig] = useState({
    [CartConfigKeys.cart]: GM_STATE.cart.initCart,
    [CartConfigKeys.isLoading]: false,
    [CartConfigKeys.isFetching]: false
  })

  const handleSetCartConfig = (key, value) => {
    setCartConfig((config) => ({ ...config, [key]: value }))
  }

  return {
    cart,
    setCart,
    isFetching,
    setIsFetching,
    isLoaded,
    setIsLoaded,
    cartConfig,
    handleSetCartConfig
  }
}

export default useCartGlobal
